import { render, staticRenderFns } from "./FloatingAd.vue?vue&type=template&id=1797d3fc"
import script from "./FloatingAd.vue?vue&type=script&lang=js"
export * from "./FloatingAd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports